<template lang="">
  <ValidationObserver ref="validator">
    <form novalidate class="md-layout generic-form" @submit.prevent="validate">
      <div class="md-layout-item md-medium-size-100 md-size-100">
        <md-card>
          <md-card-content>
            <div class="md-layout md-gutter">
              <div class="md-layout-item md-size-75 md-small-size-100">
                <ValidationProvider name="Metabse url" rules="required" v-slot="{ passed, failed }" slim>
                  <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
                    <label>Metabase Url</label>
                    <md-input v-model="metabase.metabase_url" />
                  </md-field>
                </ValidationProvider>
              </div>
            </div>
            <div class="md-layout md-gutter">
              <div class="md-layout-item md-size-25 md-small-size-100">
                <ValidationProvider name="Resources payload" :rules="{ required: true, regex: /^{.*}$/ }" v-slot="{ passed, failed }" slim>
                  <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
                    <label>Resources payload</label>
                    <md-input v-model="metabase.resource_payload" />
                  </md-field>
                </ValidationProvider>
              </div>
              <div class="md-layout-item md-size-25 md-small-size-100">
                <ValidationProvider name="Param payload" :rules="{ required: true, regex: /^{.*}$/ }" v-slot="{ passed, failed }" slim>
                  <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
                    <label>Param payload</label>
                    <md-input v-model="metabase.params_payload" />
                  </md-field>
                </ValidationProvider>
              </div>
              <div class="md-layout-item md-size-25 md-small-size-100">
                <md-field>
                  <label>Additional param</label>
                  <md-input v-model="metabase.additional_parameters" />
                </md-field>
              </div>
            </div>
            <div class="md-layout md-gutter">
              <div class="md-layout-item md-size-75 md-small-size-100">
                <ValidationProvider name="Metabse url" rules="required" v-slot="{ passed, failed }" slim>
                  <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
                    <label>Restriction Report Url</label>
                    <md-input v-model="metabase.restrictions_url" />
                  </md-field>
                </ValidationProvider>
              </div>
            </div>
            <div class="md-layout md-gutter">
              <div class="md-layout-item md-size-25 md-small-size-100">
                <ValidationProvider name="Resources payload" :rules="{ required: true, regex: /^{.*}$/ }" v-slot="{ passed, failed }" slim>
                  <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
                    <label>Restriction Resources payload</label>
                    <md-input v-model="metabase.restrictions_resource_payload" />
                  </md-field>
                </ValidationProvider>
              </div>
              <div class="md-layout-item md-size-25 md-small-size-100">
                <ValidationProvider name="Param payload" :rules="{ required: true, regex: /^{.*}$/ }" v-slot="{ passed, failed }" slim>
                  <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
                    <label>Restriction Param payload</label>
                    <md-input v-model="metabase.restrictions_params_payload" />
                  </md-field>
                </ValidationProvider>
              </div>
              <div class="md-layout-item md-size-25 md-small-size-100">
                <md-field>
                  <label>Restriction Additional param</label>
                  <md-input v-model="metabase.restrictions_additional_parameters" />
                </md-field>
              </div>
            </div>
          </md-card-content>

          <md-card-actions>
            <md-button class="md-success" type="submit">Save</md-button>
          </md-card-actions>
        </md-card>
      </div>
    </form>
  </ValidationObserver>
</template>
<script>
import { MetabaseApi } from '@/openapi/src'
import { ValidationProvider } from 'vee-validate'
import { extend } from 'vee-validate'
import { required, regex } from 'vee-validate/dist/rules'

extend('regex', regex)
extend('required', required)

const metabaseApi = new MetabaseApi()

export default {
  name: 'Metabase',
  components: {
    ValidationProvider,
  },
  data() {
    return {
      metabase: {
        restrictions_url: null,
        restrictions_params_payload: null,
        restrictions_resource_payload: null,
        restrictions_additional_parameters: null,
      },
    }
  },
  methods: {
    async validate() {
      const isValid = await this.$refs.validator.validate()
      if (isValid) {
        return this.saveMetabase()
      }
    },
    saveMetabase() {
      let metabaseNew = { ...this.metabase }
      metabaseNew.resource_payload = JSON.parse(this.metabase.resource_payload)
      metabaseNew.params_payload = JSON.parse(this.metabase.params_payload)
      metabaseNew.additional_parameters = this.metabase.additional_parameters

      metabaseNew.restrictions_resource_payload = JSON.parse(this.metabase.restrictions_resource_payload)
      metabaseNew.restrictions_params_payload = JSON.parse(this.metabase.restrictions_params_payload)
      metabaseNew.restrictions_additional_parameters = this.metabase.restrictions_additional_parameters

      metabaseApi.updateMetabaseRestriction(this.$root.hotelId, metabaseNew, (error) => {})
      this.$notify({
        timeout: 4500,
        message: 'Metabase restrictions config will be saved shortly',
        icon: 'check_box',
        horizontalAlign: 'right',
        verticalAlign: 'top',
        type: 'info',
      })
    },
  },
  created() {},
  mounted() {
    metabaseApi.getMetabase(this.$root.hotelId, (error, data) => {
      this.metabase = data
      this.metabase.resource_payload = JSON.stringify(this.metabase.resource_payload)
      this.metabase.params_payload = JSON.stringify(this.metabase.params_payload)
      this.metabase.additional_parameters = JSON.stringify(this.metabase.additional_parameters)

      this.metabase.restrictions_params_payload = JSON.stringify(this.metabase.restrictions_params_payload)
      this.metabase.restrictions_resource_payload = JSON.stringify(this.metabase.restrictions_resource_payload)
      this.metabase.restrictions_additional_parameters = JSON.stringify(this.metabase.restrictions_additional_parameters)
    })
  },
}
</script>
<style lang="scss"></style>
